export enum LoginEvents {
    reCaptcha = 'recaptcha_solicitado',
    erroSenha1x = 'errou_senha_1x',
    erroSenha2x = 'errou_senha_2x',
    erroSenha3x = 'errou_senha_3x',
    erroSenha4x = 'errou_senha_4x',
    erroSenha5x = 'errou_senha_5x',
    esqueciSenha = 'esqueci_senha',
    tokenInvalido = 'token_invalido',
    usuarioLogado = 'usuario_logado',
    tokenReenviado = 'solicitou_reenvio_token',
    usuarioBloqueado = 'usuario_bloqueado',
    novaSenhaEnviada = 'nova_senha_enviada',
}

export enum LoginEventType  {
    Error = 'Erro',
    Success = 'Sucesso'
}